import { components, MultiValueGenericProps } from 'react-select'
import { SENTIMENT_BACKGROUND_COLOR, TooltipSelectOption } from '../tooltip-select.model'

const Label = (options: TooltipSelectOption[]) => {
	const MultiValueLabel = (props: MultiValueGenericProps<TooltipSelectOption>) => {
		if (props.data.sentimentEnabled === false) {
			return (
				<div>
					<components.MultiValueLabel {...props} />
				</div>
			)
		}

		const { sentiment } = options.filter((option) => option.value === props.data.value)[0]
		let sentimentColor: string | null

		switch (sentiment) {
			case -1:
				sentimentColor = SENTIMENT_BACKGROUND_COLOR.RED
				break
			case 0:
				sentimentColor = SENTIMENT_BACKGROUND_COLOR.GRAY
				break
			case 1:
				sentimentColor = SENTIMENT_BACKGROUND_COLOR.GREEN
				break
			default:
				sentimentColor = SENTIMENT_BACKGROUND_COLOR.YELLOW
		}

		return (
			<div className="flex pl-2 justify-center items-center">
				{sentiment === null ? (
					<i style={{ fontSize: '14px' }} className="fa-light fa-empty-set text-gray-500"></i>
				) : (
					<div style={{ background: sentimentColor }} className="h-[14px] w-[14px] rounded-md"></div>
				)}
				<components.MultiValueLabel {...props} />
			</div>
		)
	}

	return {
		MultiValueLabel,
	}
}

export default Label
